import { render, staticRenderFns } from "./StatManagement.vue?vue&type=template&id=ef5b3f3e&scoped=true"
import script from "./StatManagement.vue?vue&type=script&lang=js"
export * from "./StatManagement.vue?vue&type=script&lang=js"
import style0 from "./StatManagement.vue?vue&type=style&index=0&id=ef5b3f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5b3f3e",
  null
  
)

export default component.exports